// crypto.randomUUID exists only in secure contexts (HTTPS or localhost) —
// on a plain-HTTP LAN/VPN host it is undefined and would throw. Internal
// dashboards run exactly there, so fall back to an RFC 4122 v4 built on
// crypto.getRandomValues, which is available in ALL contexts.
export const newUuid = (): string => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'))
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10).join(''),
  ].join('-')
}
